
import { defineComponent } from "vue";
import KTFolder from "@/components/files/Folder.vue";
import KTFile from "@/components/files/File.vue";

export default defineComponent({
  name: "documents",
  components: {
    KTFolder,
    KTFile,
  },
});
